<template>
  <client-only>
    <component :is="comp"></component>
    <PxModalShopAssist />
    <ExitIntentSurvey id="exit-intent-global" context="global" />
  </client-only>
</template>

<script lang="ts" setup>
  const { current } = Waypoint.use()

  const comp = computed(() =>
    defineAsyncComponent(() => import(`~/components/page/${current.value?.component}.vue`))
  )

  onMounted(() => {
    const { route, path } = AppRoute.use()
    const { routeGuard } = Auth.use()
    routeGuard(path.value)

    const { pageView } = Analytics.use()

    pageView({
      name: route.path?.toString()
    })
  })
</script>

<style scoped></style>
